import { render } from "./ListePointVentePage.vue?vue&type=template&id=6833b849&ts=true"
import script from "./ListePointVentePage.vue?vue&type=script&lang=ts"
export * from "./ListePointVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__